import { FC } from 'react'
import { Close } from '@mui/icons-material'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const CloseIcon: FC<SvgIconProps> = (props: SvgIconProps) => {
  return <Close {...props} />
}
